class CreateBiodataUseCase {
    /**
     * @param {BiodataRepository} biodataRepository
     */
    constructor(biodataRepository) {
        this.biodataRepository = biodataRepository;
    }

    /**
     * @param {object} biodataData
     * @returns {Promise<Biodata>}
     */
    async execute(biodataData) {
        return this.biodataRepository.createBiodata(biodataData);
    }
}

export default CreateBiodataUseCase;
